import { ORIENT_LABELS } from "./orient_cycle"

export function friendsPillState(friends = []) {
  const online = friends.filter(f => f.online).length
  const onTrip = friends.filter(f => f.on_trip).length
  const hidden = friends.length === 0
  return {
    hidden,
    text: hidden ? "" : `👥 ${online} online${onTrip ? ` · ${onTrip} on a trip` : ""}`
  }
}

export function followButtonState(mode) {
  return { active: mode === "following" }
}

export function liveButtonState(mode) {
  const live = mode !== "explore"
  return { active: live, label: live ? "Live" : "Explore" }
}

export function pitchButtonState(pitch3d) {
  const active = !!pitch3d
  return { active, label: active ? "2D" : "3D" }
}

export function pitchTogglePlan({ currentPitch, lastThreeDimPitch, defaultPitch }) {
  const activePitch = Number(currentPitch)
  if (Number.isFinite(activePitch) && activePitch > 0) {
    return { pitch: 0, pitch3d: false, lastThreeDimPitch: activePitch }
  }

  const savedPitch = Number(lastThreeDimPitch)
  const fallbackPitch = Number(defaultPitch)
  const pitch = Number.isFinite(savedPitch) && savedPitch > 0 ? savedPitch : fallbackPitch
  return { pitch, pitch3d: true, lastThreeDimPitch: pitch }
}

export function orientButtonState({ tracking = false, mode, orientation, labels = ORIENT_LABELS } = {}) {
  const recenter = tracking && mode !== "following"
  const label = recenter ? "◎" : (labels[orientation] || "N↑")
  const active = recenter || orientation !== "off"
  return {
    active,
    label,
    compact: label.length > 2,
    recenter
  }
}

export function basemapChoiceState(activeBasemap, choiceBasemap) {
  return { selected: choiceBasemap === activeBasemap }
}

export function mapSheetTabState(tab) {
  const basemaps = tab === "basemaps"
  return { basemaps }
}
